var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("cant-transactions", { ref: "CantTransactions" }),
      _c("processed-docs", { ref: "ProcessedDocs" }),
      _c("pending-docs", { ref: "PendingDocs" }),
      _c("config-billing-date", { ref: "ConfigBillingDate" }),
      _c("config-max-amount-invoice", { ref: "ConfigMaxAmountInvoice" }),
      _c("config-trade-name", { ref: "ConfigTradeName" }),
      _c("config-contingency-auto", { ref: "ConfigContingencyAuto" }),
      _c("config-activar-dee", { ref: "ConfigActivarDEE" }),
      _c("config-activar-ticket", { ref: "ConfigActivarTicket" }),
      _c("config-address-optional", { ref: "ConfigAddressOptional" }),
      _c("config-email-optional", { ref: "ConfigEmailOptional" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }